import request from '@hotmart/request'
import { trace } from 'utils/trace'
import { LOCALSTORAGE_TOKEN_NAME, REQUEST_SECURITY } from 'modules/auth/auth.constants'
import { USER_AUTHORITIES, USER_REQUEST_IDENTIFIERS } from 'modules/user'
import UserVO from './user.vo'
import '../user.requests'

function verifyIsBuyer(authorities): boolean {
  return (
    authorities &&
    authorities.includes(USER_AUTHORITIES.USER_BUYER) &&
    !authorities.includes(USER_AUTHORITIES.USER_ATTENDANT) &&
    !authorities.includes(USER_AUTHORITIES.USER_PRODUCER)
  )
}

/**
 * Check if user is producer or seller
 *
 * @param authorities - authorities
 */
function verifyIsProducerOrSeller(authorities): boolean {
  return (
    authorities &&
    (authorities.includes(USER_AUTHORITIES.USER_PRODUCER) || authorities.includes(USER_AUTHORITIES.USER_SELER))
  )
}

function hasSignupRole(profile): boolean {
  return profile?.roles?.map((item: UserVO) => item.name).includes(USER_AUTHORITIES.USER_PLATFORM_SIGNUP)
}

export default class UserDAO {
  async get(): Promise<UserVO | null> {
    let authorities: string[] = []

    try {
      const profile = await request(USER_REQUEST_IDENTIFIERS.PROFILE)

      if (profile?.id) {
        try {
          const data = await request(REQUEST_SECURITY.CHECK_TOKEN, {
            access_token: localStorage.getItem(LOCALSTORAGE_TOKEN_NAME)
          })

          authorities = data.authorities
        } catch (e) {
          authorities = []
          console.error(e)
        }
      } else {
        trace.trhowMsg('[trace][7] API profile no content')
        return null
      }

      const {
        id,
        ucode,
        name,
        email,
        locale: language,
        defaultCurrency,
        attendantId,
        attendantEmail,
        address
      } = profile

      return {
        id,
        name,
        ucode,
        email,
        language,
        defaultCurrency,
        isBuyer: verifyIsBuyer(authorities),
        isProducerOrSeller: verifyIsProducerOrSeller(authorities),
        isFromFrance: authorities.includes(USER_AUTHORITIES.USER_FR),
        authorities,
        hasSignupRole: hasSignupRole(profile),
        coProductions: [],
        affiliations: [],
        productions: [],
        entityType: profile.entityType,
        profile,
        attendant: Boolean(attendantId),
        attendantId,
        attendantEmail,
        address
      }
    } catch (e) {
      console.error(e)
      return null
    }
  }

  async getIsFromBrazil() {
    const userFromResponse = await request(USER_REQUEST_IDENTIFIERS.USER_FROM, { countryIsoCode: 'BR' })

    return { isFromBrazil: Boolean(userFromResponse?.isSameCountry) }
  }
}
